'use client'

import './MessageDefault.css';

const MessageDefault: React.FC = () => {
    return (
        <div className='box-message'>
            <h2 className="title-default">Para que o formulário esteja disponível, é necessário ativar os cookies de funcionalidade. <br/> Esses cookies permitem o correto funcionamento dos recursos essenciais da página.</h2>
            <p className="description-default">Por favor, habilite-os nas suas Configurações de Cookies para continuar.</p>
        </div>
    )
};

export default MessageDefault;